<template>
  <o-modal
    :active.sync="isActive"
    content-class=""
  >
    <div class="tw-p-10">
      <!-- This is specifically for Concentration Breakdown -->
      <!-- It will be blank for other charts -->
      <h2 class="tw-text-xl tw-font-bold tw-text-center">
        {{ title || clickData?.label }}
        <div v-if="tableData && download" class="tw-mt-4 tw-flex tw-justify-end">
          <a @click="downloadCSV" href="javascript:void(0)" class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
            <i class="fas fa-download fa-sm tw-mr-2"></i> Download Table Data
          </a>
        </div>
        <div v-if="tableData && download && portfolioExternalId" class="tw-mt-4 tw-flex tw-justify-end">
          <a @click="downloadFullConcentration" href="javascript:void(0)" class="tw-text-blue-500 tw-text-sm tw-flex tw-items-center">
            <i class="fas fa-download fa-sm tw-mr-2"></i>
            Download Full Portfolio Concentration
          </a>
        </div>
        <!-- Show spinner while loading -->
        <div v-if="loadingFullConcentration" class="tw-flex tw-justify-center tw-my-4">
          <i class="fas fa-spinner fa-spin fa-2x tw-text-blue-500"></i>
        </div>
      </h2>

      <SimpleTable
        v-if="tableData"
        :init-table-data="tableData"
      />
      <p v-else>
        Chart details for this analysis type are not quite ready yet. Check back soon!
      </p>
    </div>
  </o-modal>
</template>

<script>
import SimpleTable from '@frontend/ui/components/core/SimpleTable.vue';

export default {
  name: 'ChartClickthroughs',
  components: { SimpleTable },
  props: {
    clickData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    getTableData: {
      type: Function,
      required: false,
      default: () => (undefined),
    },
    download: {
      type: Boolean,
      required: false,
      default: true,
    },
    portfolioExternalId: {
      type: String,
      required: false,
    },
    benchmarkExternalId: {
      type: String,
      required: false,
    },
    optimizedPortfolioExternalId: {
      type: String,
      required: false,
    },
    portfolioName: {
      type: String,
      required: false,
    },
    benchmarkName: {
      type: String,
      required: false,
    },
    optimizedPortfolioName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isActive: false,
      tableData: null,
      title: null,
      loadingFullConcentration: false,
    };
  },
  computed: {
    chartOptions() {
      return this.clickData?.options;
    },
    chartTitle() {
      return this.chartOptions?.plugins?.title?.text;
    },
  },
  watch: {
    clickData: {
      handler() {
        this.isActive = true;
        const data = this.getTableData(this.clickData);
        if (data) {
          this.tableData = data.table;
          this.title = data.title;
        }
      },
      deep: true,
    },
  },
  methods: {
    async downloadFullConcentration() {
      let portfolioId = null;
      let fileName = null;

      if (this.chartOptions?.plugins?.title?.text === this.portfolioName) {
        portfolioId = this.portfolioExternalId;
        fileName = this.portfolioName;
      } else if (this.chartOptions?.plugins?.title?.text === this.benchmarkName) {
        portfolioId = this.benchmarkExternalId;
        fileName = this.benchmarkName;
      } else if (this.chartOptions?.plugins?.title?.text === this.optimizedPortfolioName) {
        portfolioId = this.optimizedPortfolioExternalId;
        fileName = this.optimizedPortfolioName;
      }

      if (portfolioId) {
        this.loadingFullConcentration = true; // Start loading spinner

        try {
          const url = `/api/v1/portfolios/${portfolioId}/download-holdings-concentration/`;
          
          // Fetch the file
          const response = await fetch(url);
          const blob = await response.blob();
          const downloadUrl = window.URL.createObjectURL(blob);
          
          // Create a temporary link to trigger the download
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", `holdings-concentration-${fileName}.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Revoke the object URL after download
          window.URL.revokeObjectURL(downloadUrl);

        } catch (error) {
          console.error('Error downloading the file:', error);
        } finally {
          this.loadingFullConcentration = false; // Stop loading spinner
        }
        
      } else {
        console.log('No valid portfolioId found');
      }
    },
    downloadCSV() {
      if (!this.tableData) return;

      const rows = [Object.keys(this.tableData[0])];
      this.tableData.forEach(row => {
        rows.push(Object.values(row));
      });

      const csvContent = rows.map(e => e.join(";")).join("\n");
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `${this.title || this.chartOptions?.plugins?.title?.text}-${this.clickData?.label || 'data'}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
</style>
